<template>
  
   <div class="container">
	<div class="sidebar">
		
   <my-component></my-component>
   
  </div>
  
  <div class="content">
	  <div class="tx" >
	  	  <div class="title"  >
	  		 <div class="page-header">
	  		  最近存证</div>
	  		<el-select
	  		  @change="selectChanged"
	  		  v-model="value"
	  		  placeholder="请选择权证类型"
	  		>
	  		  <el-option
	  			v-for="item in options"
	  			:key="item.value"
	  			:label="item.label"
	  			:value="item.value"
	  		  >
	  		  </el-option>
	  		</el-select>
	  	  </div>
	  	  <div
	  		class="mobile_cell"
	  		v-for="(item, index) in tableData1"
	  		:key="index + ''"
	  	  >
	  		<van-cell-group :border="false">
				
	  		  <van-cell title="存证哈希" :value="item.tx_hash" :border="false">
	  			<template>
	  			  <router-link
	  				style="text-decoration: none"
	  				:to="{
	  				  path: '/txDetail',
	  				  query: { tx_hash: item.tx_hash },
	  				}"
	  				>{{ item.tx_hash }}
	  			  </router-link>
	  			</template>
	  		  </van-cell>
	  		  <van-cell title="存证类型" :border="false">
	  			{{ item.memo | numFilter }}
	  		  </van-cell>
	  		  <van-cell title="区块高度" :value="item.height" :border="false">
	  			<template>
	  			  <router-link
	  				style="text-decoration: none"
	  				:to="{
	  				  path: '/blockDetail',
	  				  query: { height: item.height },
	  				}"
	  				>{{ item.height }}
	  			  </router-link>
	  			</template>
	  		  </van-cell>
	  		  <van-cell title="存证时间" :value="item.time" :border="false" />
	  		</van-cell-group>
	  	  </div>
	  	</div>
	  	<div class="pagination" >
	  	    <el-pagination
			v-model="currentPage"
	  	      @current-change="getPage"
	  	      :page-size="5"
	  	      :total="100"
	  	      :pager-background="true"
	  	      :background="true"
	  	      layout="prev, pager, next"
	  	    >
	  	    </el-pagination>
	  	  </div>
	  </div>
  </div>
</template>

<script>
	import MyComponent from '@/components/MyComponent.vue';
	import Memo from "../components/Memo.vue";
	export default {
	  components: {  MyComponent },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      tableData1: [],
      options: [
        {
          value: 100000,
          label: "全部类型",
        },
        {
          value: 100001,
          label: "产品交易",
        },
        {
          value: 100002,
          label: "企业积分",
        },
        {
          value: 100003,
          label: "平台积分",
        },
        {
          value: 100004,
          label: "权益积分",
        },
        {
          value: 100005,
          label: "平台积分",
        },
        {
          value: 100006,
          label: "积分兑换",
        },
        {
          value: 100011,
          label: "余额充值",
        },
      ],
    };
  },
  filters: {
    numFilter(value) {
      let ID = "";
      if (
        value &&
        Object.prototype.toString.call(value) === "[object Object]"
      ) {
        if (
          value.message &&
          Object.prototype.toString.call(value.message) === "[object Array]"
        ) {
          ID = value.message[0];
        } else if (value.indexID) {
          ID = value.indexID;
        } else {
        }
      }
      switch (ID) {
        case "100000":
          ID = "全部类型";
          break;
        case "100001":
          ID = "产品交易";
          break;
        case "100002":
          ID = "企业积分";
          break;
        case "100003":
          ID = "全部类型";
          break;
        case "100004":
          ID = "权益积分";
          break;
        case "100005":
          ID = "平台积分";
          break;
        case "100006":
          ID = "积分兑换";
          break;
        case "100011":
          ID = "余额充值";
          break;
        default:
          break;
      }
      return ID;
    },
  },
  computed: {
    value() {
      let ID = "";
      switch (this.$route.query.project) {
        case "100000":
          ID = "全部类型";
          break;
        case "100001":
          ID = "产品交易";
          break;
        case "100002":
          ID = "企业积分";
          break;
        case "100003":
          ID = "全部类型";
          break;
        case "100004":
          ID = "权益积分";
          break;
        case "100005":
          ID = "平台积分";
          break;
        case "100006":
          ID = "积分兑换";
          break;
        case "100011":
          ID = "余额充值";
          break;
        default:
          break;
      }
      return ID;
    },
  },
  mounted() {
    this.getTxTable();
    this.timer = window.setInterval(() => {
      setTimeout(this.getTxTable(), 0);
    }, 3000);
  },
  methods: {
    selectChanged(value) {
      this.$router.push({
        path: "/transaction",
        query: {
          project: value,
        },
      });
    },
    getTxTable() {
      let query = this.$route.query.project;
      let filterArray = [];
      if (!query || query == "100000") {
        this.$http
          .get(`${block_ip}txs/${this.currentPage}/${this.pageSize}`)
          .then((res) => {
            if (res.data.data) {
              this.tableData1 = res.data.data;
            }
          });
      } else {
        this.$http
          .get(`${block_ip}txs/${this.currentPage}/${this.pageSize}`)
          .then((res) => {
            if (res.data.data) {
              filterArray = res.data.data.filter((element) => {
                if (element.memo.message) {
                  return element.memo.message[0] === query;
                } else if (element.memo.indexID) {
                  return element.memo.indexID === query;
                }
              });
              this.tableData1 = filterArray;
            }
          });
      }
    },
    getPage(value) {
      this.currentPage = value;
      this.getTxTable();
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
	.container {
	  display: flex;
	  min-height: 100vh;
	}
	
	.sidebar {
	  flex:1;
	  height: 100vh; /* 侧边栏高度 */
	  
	}
	
	
	.content {
	  flex:9;
	  padding: 20px; /* 内容区域的内边距 */
	  background-color: rgb(37,49,63);
	}
.mobile_cell {
  background-color: rgb(37,49,63);
  border: none;
  padding:10px;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.van-cell {
  padding: 10px 16px 10px 16px;
  background-color: rgb(26,35,45);
  color:white;

}
.van-cell-group {
	border: none;
	
}

.block {
  margin: 0 5px;
  background-color:rgb(26,35,45);
}
.pagination {
  margin: 0 12px;
  width:300px;
  margin-left: 35%;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
a {
  color: white ; /* 设置链接的颜色为黑色 */
  text-decoration: none; /* 移除下划线 */
}
.page-header {
  padding: 15px; /* 根据需要调整内边距 */
  background-color: rgb(37,49,63); /* 背景颜色 */
  position: relative; /* 相对定位，如果需要定位子元素 */
  font-size:20px;
  color:white;
  font-weight:bold;
}


/* 修改分页按钮的背景色和文字颜色 */
.el-pagination  {
  color: #fff !important;
  
}


</style>
